module.exports = __webpack_public_path__ + "images/noaccess_smalldc5005d6a822a80efd7e44dfd902086c.png";